import React from 'react';
import { useApolloClient } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { Box } from '@components/layout/Grid';
import DocumentOverlay from './DocumentOverlay';
import {
  ProgramCategory,
  ProgramDocument,
  useSaveGenericProgramProgressMutation,
} from '@gql/generated';
import AnalyticsManager from '@lib/analytics/manager';

type Props = {
  programTitle: string;
  programId: string;
  hasAccess: boolean;
  programQuery: DocumentNode;
  currentElement: ProgramDocument;
  programCategory: ProgramCategory;
  programProgress: number;
};

const ProgramDocumentWindow = ({
  programId,
  currentElement,
  hasAccess,
  programQuery,
  programProgress,
  programCategory,
  programTitle,
}: Props) => {
  const client = useApolloClient();
  const [saveProgramProgress] = useSaveGenericProgramProgressMutation();

  async function updateVideoProgress() {
    if (!currentElement.locked && !currentElement.finished) {
      return saveProgramProgress({
        variables: {
          documentPartId: currentElement.id,
          videoPartId: null,
          programPartElementId: null,
          liveEventPartId: null,
        },
      });
    }
  }

  function refetchPogram() {
    client
      .query({
        query: programQuery,
        variables: { slug: programId },
        fetchPolicy: 'network-only',
      })
      .then(resp => {
        // send program completed event
        if (programProgress < 100 && resp?.data?.progress === 100) {
          AnalyticsManager().sendProgramCompletionEvent({
            title: programTitle,
            category: programCategory,
            slug: programId,
          });
        }
      });
  }

  return (
    <Box data-testid="VideoPlayerSection">
      <Box style={{ position: 'relative' }}>
        <DocumentOverlay
          title={currentElement.title}
          description={currentElement['description']}
          documentURL={process.env.DOMAIN + currentElement.document.url}
          programCategory={programCategory}
          hasAccess={hasAccess}
          documentOpened={async () => {
            await updateVideoProgress();
            refetchPogram();
          }}
        />
      </Box>
    </Box>
  );
};

export default ProgramDocumentWindow;
